import Constants from '@usas/ui-web/utils/Constants';
import { isValidDate } from '@usas/ui-web/utils/validation';

export const localValidate = (formState) => {
  let errors = {};

  if (formState.lscId === Constants?.DEFAULT_ID) {
    errors.lscId = 'LSC is required to search for LSC officials';
  }
  if (formState.certificationLevelId === Constants?.DEFAULT_ID) {
    errors.certificationLevelId = 'Certification Level is required to search for LSC officials';
  }
  if (formState.officialPositionTypeId === Constants?.DEFAULT_ID) {
    errors.officialPositionTypeId = 'Position Worked is required to search for LSC officials';
  }

  //Expiration Dates
  const localFromExpirationDate = new Date(formState.fromExpirationDate);
  const localToExpirationDate = new Date(formState.toExpirationDate);

  if (formState.fromExpirationDate !== Constants.BLANK_DATE_STRING && !isValidDate(formState.fromExpirationDate)) {
    errors.fromExpirationDate = 'From Expiration Date must be a valid date';
  }

  if (formState.toExpirationDate !== Constants.BLANK_DATE_STRING && !isValidDate(formState.toExpirationDate)) {
    errors.toExpirationDate = 'To Expiration Date must be a valid date';
  }

  if (!errors.fromExpirationDate && !errors.toExpirationDate) {
    if (localFromExpirationDate > localToExpirationDate) {
      errors.fromExpirationDate = 'From Expiration Date must be on or before the To Expiration Date';
      errors.toExpirationDate = 'To Expiration Date must be on or after the From Expiration Date';
    }
  }

  return errors;
};

const HqOtsOfficialLscBulkCertificationValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default HqOtsOfficialLscBulkCertificationValidation;